const DOCUMENT = 'SUB_UNIT_';

const actions = {
  ADD: DOCUMENT + 'ADD',
  CANCEL: DOCUMENT + 'CANCEL',
  CHANGE_PROPERTIES: DOCUMENT + 'CHANGE_PROPERTIES',
  CHANGE_PROPERTY: DOCUMENT + 'CHANGE_PROPERTY',
  CLEAR_STORE: DOCUMENT + 'CLEAR_STORE',
  CREATE: DOCUMENT + 'CREATE',
  DELETE: DOCUMENT + 'DELETE',
  DELETE_SUCCESS: DOCUMENT + 'DELETE_SUCCESS',
  EDIT: DOCUMENT + 'EDIT',
  FILTER_UNITS: DOCUMENT + 'FILTER_UNITS',
  FILTER_UNITS_SUCCESS: DOCUMENT + 'FILTER_UNITS_SUCCESS',
  LOAD: DOCUMENT + 'LOAD',
  LOAD_FORM_DATA: DOCUMENT + 'LOAD_FORM_DATA',
  LOAD_FORM_DATA_SUCCESS: DOCUMENT + 'LOAD_FORM_DATA_SUCCESS',
  LOAD_MANAGERS_FORM_DATA: DOCUMENT + 'LOAD_MANAGERS_FORM_DATA',
  LOAD_SUCCESS: DOCUMENT + 'LOAD_SUCCESS',
  SAVE: DOCUMENT + 'SAVE',
  SAVE_ERROR: DOCUMENT + 'SAVE_ERROR',
  SAVE_SUCCESS: DOCUMENT + 'SAVE_SUCCESS',
  SET_SELECTED_UNIT: DOCUMENT + 'SET_SELECTED_UNIT',
  TOUCH: DOCUMENT + 'TOUCH',

  add: data => ({ type: actions.ADD, payload: data }),
  cancel: () => ({ type: actions.CANCEL }),
  changeProperties: data => ({ type: actions.CHANGE_PROPERTIES, payload: data }),
  changeProperty: data => ({ type: actions.CHANGE_PROPERTY, payload: data }),
  clearStore: () => ({ type: actions.CLEAR_STORE }),
  create: data => ({ type: actions.CREATE, payload: data }),
  delete: data => ({ type: actions.DELETE, payload: data }),
  deleteSuccess: () => ({ type: actions.DELETE_SUCCESS }),
  edit: data => ({ type: actions.EDIT, payload: data }),
  filterUnits: data => ({ type: actions.FILTER_UNITS, payload: data }),
  filterUnitsSuccess: data => ({ type: actions.FILTER_UNITS_SUCCESS, payload: data }),
  loadData: data => ({ type: actions.LOAD, payload: data }),
  loadDataSuccess: data => ({ type: actions.LOAD_SUCCESS, payload: data }),
  loadFormData: data => ({ type: actions.LOAD_FORM_DATA, payload: data }),
  loadFormDataSuccess: data => ({ type: actions.LOAD_FORM_DATA_SUCCESS, payload: data }),
  loadManagersFormData: data => ({ type: actions.LOAD_MANAGERS_FORM_DATA, payload: data }),
  save: data => ({ type: actions.SAVE, payload: data }),
  saveError: data => ({ type: actions.SAVE_ERROR, payload: data }),
  saveSuccess: () => ({ type: actions.SAVE_SUCCESS }),
  setSelectedUnit: data => ({ type: actions.SET_SELECTED_UNIT, payload: data }),
  touch: data => ({ type: actions.TOUCH, payload: data }),
};

export default actions;
